import { useNavigate, useSearchParams, useParams } from "react-router-dom";




export const useAppRouter = (route) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const params = useParams();

    // Retornamos uma função que o seu componente vai chamar
    const appNavigate = (to, options = {}) => {
        if(to == -1){
            navigate(-1);
            return;
        }

        const currentParams = searchParams.toString();
        const queryString = currentParams ? `?${currentParams}` : '';
        
        // Se o caminho não começar com /, adiciona o caminho base
        let targetPath = to;

        if (!to.startsWith('/')) {
            targetPath = `/${params.company}/${params.companyId}/${to}`;
        }
        
        navigate(`${targetPath}${queryString}`, options);
    };

    return appNavigate;
}